import { createAction } from '@reduxjs/toolkit'

export const typeAmount = createAction<{ typedAmount: string }>('bridgeERC20/typeAmount')
export const typeRecipient = createAction<{ typedRecipient: string }>('bridgeERC20/typeRecipient')
export const selectCurrency = createAction<{ currencyId: string }>('bridgeERC20/selectCurrency')
export const selectSourceChain = createAction<{ sourceChainId: number }>('bridgeERC20/selectSourceChain')
export const selectTargetChain = createAction<{ targetChainId: number }>('bridgeERC20/selectTargetChain')
export const setDeposit = createAction<{ sourceChainId: number; depositHash: string }>('bridgeERC20/setDeposit')
export const reset = createAction('bridgeERC20/reset')
